<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni <$email>

  This file TicketEntityPreview.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  TicketEntityPreview.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: TicketEntityPreview 
 Created by keni.
 with: IntelliJ IDEA
 Date: 15/05/2018
 Time: 11:16
------------------------------------------------------------------------------->
<template>
    <div data-ref="entity-preview--component" class="position-absolute">
        <div :data-preload="preloadImage()"></div>
        <transition name="fadeLeftBig"
        >
            <!--preview entity details-->
            <div v-if="show_entity"
                 class="modal-entity-preview"
                 ref="preview_wrapper"
                 :class="{
                    'active':show_entity
                 }"
                 :style="styleObject"
            >
                <div class="pointer--arrow"></div>
                <div class="modal-entity-preview--container">
                    <header-overlay
                            header_class="py-0 clearfix text-center"
                            @headerClick="close_preview"
                    >
                        <template slot="content">
                            <div class="d-flex justify-content-between align-items-center">
                                <street-sign v-if="entity.entity_data.sign">
                                    <template slot="content">
                                        {{entity.entity_data.sign}}
                                    </template>
                                </street-sign>
                                <template v-else>
                                    <InfoButton> </InfoButton>
                                </template>
                                <h6 class="m-0 text-truncate">
                                    {{lang('title',entity.entity_data.lang)}}
                                </h6>

                                <div class="lh-0 float-right border-0 cursor-pointer"
                                     role="button"
                                >
                                    <i class="icon-180-x-hover material-icons" aria-hidden="true">close</i>
                                </div>
                            </div>
                        </template>
                    </header-overlay>
                    <!--Card image-->
                    <div
                            class="view overlay modal-entity-preview--overlay"
                            v-if="entity.images.length > 0"
                    >
                        <ImageResponsive
                                :image="entity.images.length > 0?entity.images[0]:null"
                                :alt="lang('title',entity.entity_data.lang)"
                                default_size="sm"
                                class="my-2"
                        >
                        </ImageResponsive>
                    </div>
                    <!--/Card image-->

                    <!--Card content-->
                    <div class="">
                        <div class=" card-body">
                            <div class="card-text mb-1"
                                 v-html="lang('description',entity.entity_data.lang).short"
                            ></div>
                            <div class="card-text mb-1"
                                 v-html="lang('description',entity.entity_data.lang).long"
                            ></div>
                        </div>
                        <div v-if="entity.entity_data.sign" class="card-footer">
                            <div class=" text-muted row align-items-center">
                                <div class="col-4">
                                    <street-sign v-if="entity.entity_data.sign">
                                        <template slot="content">
                                            {{entity.entity_data.sign}}
                                        </template>
                                    </street-sign>
                                </div>
                                <div class="col-8">
                                    Look for this <strong>sign</strong> when getting closer to your destination.
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--/.Card content-->
                </div>
            </div>
        </transition>
    </div>

</template>

<script>
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {HUB, CDN_URL, BUCKET_NAME, IMAGE_URL_BASE} from '../../config/config';
    import {readImageFromData, createMainImage} from '../../../../../app/Shared/Resources/Assets/js/helpers/images';

    Vue.component('header-overlay', require('../../../../../app/Shared/Resources/Assets/js/components/headers/HeaderOverlay'));
    Vue.component('street-sign', require('../../../../../app/Shared/Resources/Assets/js/components/StreetSign'));
    export default {
        name: "ticket-entity-preview",
        components: {},
        props: {
            width: Number,
            position_offset: Number,
            // display_entities: Function|Object,
            /**
             * @property entity_data.images_array
             * @property entity_data
             * @property id
             * @namespace
             */
            entity: Function | Object,
            displayChanged: Function | Boolean
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            // console.log('this.images_url', this.images_url);

        },
        data() {
            return {
                main_image: '',
                show_entity: false,
                images: Array,
                styleObject: {}
            }
        },
        methods: {
            log() {
                console.log.apply(console, arguments);
            },
            readImageFromData(entity) {
                let image = readImageFromData(entity);
                console.log('entity', entity)
                return image;
            },
            applyImage(entity) {
                if (this.main_image !== '') {
                    return this.main_image;
                }
            },
            close_preview() {
                this.$emit('close_preview', true)
            },
            lang(path, object) {
                return lang(path, object)
            },
            preloadImage() {
                if (typeof this.entity !== 'undefined' && typeof this.entity !== 'function' && this.entity !== null) {
                    // console.log('this.entity',this.entity);

                    if (!this.entity.hasOwnProperty('entity_data')) {
                        return null;
                    }

                    let url = createMainImage(this.entity.entity_data.images_array);
                    // console.log('url',url);
                    if (url === null) {
                        return null;
                    }
                    if (url in this.images) {
                        return this.images[url];
                    } else {
                        let my_image = new Image();

                        my_image.onload = function () {
                            // console.log('image loaded');
                        };

                        my_image.src = url;
                        this.$set(this.images, url, my_image);
                        // this.images.put(url,my_image);
                        return my_image;
                    }
                }
            },
        },
        watch: {
            displayChanged: function (itemOld, itemNew) {
                // console.log('itemOld',itemOld,'itemNew',itemNew);
                // console.log('this.displayChanged',this.displayChanged);
                // console.log('displayChanged', 'this.display_entities', this.display_entities, this.entity);
                this.show_entity = this.displayChanged;
                this.styleObject = {
                    width: this.width + 'px',
                    left: this.position_offset + 'px'
                }
                // this.$refs.preview_wrapper.clientWidth = this.width
// console.log('this.show_entity',this.show_entity);
            },
        },
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/tickets/TicketEntityPreview.vue